import React from "react";
import { Row, Col, Badge } from "react-bootstrap";
import "./CareerBoosterContent.css"; // Isolated left-side CSS

function CareerBoosterContent() {
  return (
    <div className="career-content-scrollable pe-lg-3">
   

      <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
        <h1 className="fw-bold h3 m-0">Career Booster</h1>
        <Badge
          bg="warning"
          className="text-dark bg-opacity-25 border border-warning rounded-pill px-2 py-1 small fw-semibold"
        >
          ★ Best-Seller
        </Badge>
      </div>

      <p className="text-secondary mb-3 fs-6 col-xl-10 ps-0">
        Experience the best of our services! Top recruiter search results
        and boost your chances of getting shortlisted for interviews — all
        at an unbeatable price.
      </p>

      <Badge
        bg="danger"
        className="bg-opacity-10 text-danger mb-4 px-2 py-1 fw-normal"
      >
        250+ bought recently
      </Badge>

      {/* Feature Banner Section */}
      <div className="hero-purple-banner mb-4">
        <img
          src="/assets/Images/CareerBooster/career-booster.gif"
          className="gif_holder"
          alt="gif"
        />
      </div>

      {/* Core Perks Highlights */}
      <Row className="g-4 text-start perk-highlights mb-5">
        <Col md={4} className="border-end-md">
          <h3 className="perk-title">Rank  Higher</h3>
          <p className="text-muted small m-0">Show up in top search results</p>
        </Col>
        <Col md={4} className="border-end-md">
          <h3 className="perk-title">1-on-1  Access</h3>
          <p className="text-muted small m-0">Direct access to writers</p>
        </Col>
        <Col md={4}>
          <h3 className="perk-title">High ATS  Score</h3>
          <p className="text-muted small m-0">Above 70% ATS compliance</p>
        </Col>
      </Row>
    </div>
  );
}

export default CareerBoosterContent;